import { CSSProperties, PropsWithChildren } from "react"

export type InsetValue = "sm" | "md" | "lg"

const insetValueMap: Record<InsetValue, CSSProperties["paddingTop"]> = {
  sm: "var(--spacing-sm)",
  md: "var(--spacing-md)",
  lg: "var(--spacing-lg)",
}

interface InsetProps extends PropsWithChildren {
  className?: string
  top?: InsetValue
  right?: InsetValue
  bottom?: InsetValue
  left?: InsetValue
}

export const Inset = ({ children, className, top, right, bottom, left }: InsetProps) => {
  const insetStyles: CSSProperties = {
    paddingTop: top ? insetValueMap[top] : undefined,
    paddingRight: right ? insetValueMap[right] : undefined,
    paddingBottom: bottom ? insetValueMap[bottom] : undefined,
    paddingLeft: left ? insetValueMap[left] : undefined,
  }

  return (
    <div className={className} style={insetStyles}>
      {children}
    </div>
  )
}

export default Inset
